import { Directive, ElementRef, inject, OnInit, Renderer2 } from "@angular/core";

@Directive({
  selector: "[Asterisk]",
})
export class AsteriskDirective implements OnInit {
  private renderer = inject(Renderer2);
  private element = inject(ElementRef);

  ngOnInit() {
    const span = this.renderer.createElement("span");
    const text = this.renderer.createText("*");
    span.style.color = "red";
    span.style.fontSize = "14px";
    span.style.marginLeft = "5px";
    span.appendChild(text);
    this.element.nativeElement.appendChild(span);
  }
}
